import * as React from 'react';
import type { SVGProps } from 'react';

const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 59 53" {...props}>
    <path
      fill="currentColor"
      d="M46.614 0h9.044L35.8 22.49 59 53H40.795L26.54 34.46 10.223 53H1.18l21.036-24.055L0 0h18.657l12.878 16.937zM43.45 47.72h5.013L16.023 5.085h-5.387z"
    />
  </svg>
);

export default SvgTwitter;
